import { createSlice } from '@reduxjs/toolkit';
import { PSP, UNKNOWN_PSP } from 'shared/types/checkout';
import { makePropertyReducer } from 'store/utils';
import { CheckoutState, PaymentCTAPayload } from './types';

const getPropertyReducer = makePropertyReducer<CheckoutState>();

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState: {
    alert: { code: null },
    isCTADisabled: false,
    isPayPalCTAPending: false,
    isStripeCTAPending: false,
    isFreeOrderCTAPending: false,
  } as CheckoutState,
  reducers: {
    ...getPropertyReducer('alert'),
    ...getPropertyReducer('isCTADisabled'),
    clearAlert(state) {
      state.alert = { code: null };
    },
    setPaymentCTAState(state, { payload: { psp, value } }: PaymentCTAPayload) {
      state.isCTADisabled = value;
      if (psp === PSP.PAYPAL) {
        state.isPayPalCTAPending = value;
      } else if (psp === PSP.STRIPE) {
        state.isStripeCTAPending = value;
      } else if (psp === UNKNOWN_PSP.Type) {
        state.isFreeOrderCTAPending = value;
      }
    },
  },
});

export const {
  actions: { setAlert, clearAlert, setIsCTADisabled, setPaymentCTAState },
  reducer: checkoutReducer,
} = checkoutSlice;
